import React from 'react';
import classNames from 'classnames';
type ArtifactViewCodeDiffHeaderProps = {
  text?: string;
};
const ArtifactViewCodeDiffHeader: React.SFC<ArtifactViewCodeDiffHeaderProps> = props => {
  let text = props.text,
    colorClasses = classNames({
      'col-1-1 pv--- ph': true,
      'font-family--code': true,
      'bg-color--white-medium': true,
      'bo-b--1 border-color--white-dark': true,
    });
  return <div className={colorClasses}>{text}</div>;
};
export default ArtifactViewCodeDiffHeader;
